import React from "react";
import { ContactSec } from "./contact";

export const Contact = () => {
  return (
    <React.Fragment>
      <div className="contact-main">
        <ContactSec />
      </div>
    </React.Fragment>
  );
};
